import useTranslation from "next-translate/useTranslation";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { DonatePageContext } from "../../context/DonatePageContext";
import MolhamButton from "./MolhamButton";

type Props = {
  title: string;
  url: string;
  close: () => void;
};
const NativeMobileShareBtn = ({ title, url, close }: Props) => {
  const dntCtx = useContext(DonatePageContext);

  const titleFromSingleCase =
    //@ts-ignore
    dntCtx?.data?.contents?.short_name
      ? //@ts-ignore
        dntCtx?.data?.contents?.short_name
      : title;
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation("common");

  const handleSharing = async () => {
    setIsLoading(true);
    if (navigator.share) {
      try {
        await navigator
          .share({
            url,
            title,
          })
          .then(() => {
            close();
          });
      } catch (error) {
        // toast.error(error);
        // toast.error(
        //   `Oops! I couldn't share to the world because: ${error.message}`
        // );
      }
    } else {
      toast.error(
        "Web share is currently not supported on this browser. Please provide a callback"
      );
      // fallback code
    }
    setIsLoading(false);
  };

  return (
    <div className="px-3">
      <MolhamButton
        id="mobile-share-btn"
        label={`${t(`share-2`)} ${titleFromSingleCase}`}
        className="text-capitalize mt-3 w-100"
        startIcon="fe-share-2 share-btn"
        onClick={handleSharing}
        isLoading={isLoading}
      />
    </div>
  );
};

export default NativeMobileShareBtn;
